








































































import Vue from "vue";
import { User, UserGroup } from "@infoland/iprova-api";
import CardProperty from "./CardProperty.vue";

export default Vue.extend({
    name: "UserCard",
    components: { CardProperty },
    props: {
        /** The user represented by this card */
        user: { type: Object as () => User, required: true }
    },
    data: function () {
        return {
            /** model for the tab selector */
            tab: null as number
        };
    },
    computed: {
        /** Gets the id of the card */
        cardId(): string {
            return `extraInfoCard_${this.user.user_id}`;
        },
        /** gets whether the user on this card has organisation units */
        hasOrganisationalUnits(): boolean {
            return this.user.organization_units && this.user.organization_units.length > 0;
        }
    },
    methods: {
        /** Gets the names of the organisation units of the user
         * @returns The names of the user's organisation units
         */
        getOrganizationUnitNames(): string {
            return this.user.organization_units.map(ou => ou.name).join();
        },
        /** Gets the user groups the user is in (but not the system groups), sorted by alphabet
         * @returns the user groups of the user, sorted by alphabet
         */
        getSortedUserGroupsWithoutSystemGroups(): UserGroup[] {
            const returnvalue: UserGroup[] = [].concat(this.user.user_groups.filter(ug => !(ug as any).is_system_group));
            return returnvalue.sort((a, b) => {
                const texta: string = a.name.toUpperCase();
                const textb: string = b.name.toUpperCase();
                return texta < textb ? -1 : texta > textb ? 1 : 0;
            });
        },
        /** closes the card (by emitting 'close') */
        closeCard(): void {
            this.$emit("close");
        }
    }
});
